import React from 'react'
import PropTypes from 'prop-types'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table'
import {Button} from 'react-bootstrap'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import * as helpers from '../lib/HelperFunctions'

class ViabilityTable extends React.Component {

    onAfterInsertRow(row) {
        this.props.onAddRow(row)
    }
    customConfirm(next, dropRowKeys) {
        // const dropRowKeysStr = dropRowKeys.join(',')
        // if (confirm(`(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`)) {
        //     // If the confirmation is true, call the function that
        //     // continues the deletion of the record.
            next()
        // }
    }
    onAfterDeleteRow(rowKeys) {
        this.props.onDeleteRow(rowKeys)
    }
    onAfterSaveCell(row, cellName, cellValue) {
        this.props.onEditRow(row)
    }
    onBeforeSaveCell(row, cellName, cellValue) {
        // You can do any validation on here for editing value,
        // return false for reject the editing
        return true
    }
    // validator function pass the user input value and row object. In addition, a bool return value is expected
    whatColValidator(value, row) {
        const response = { isValid: true, notification: { type: 'success', msg: '', title: '' } }
        if (!value) {
            response.isValid = false
            response.notification.type = 'error'
            // response.notification.msg = 'Value must be inserted'
            response.notification.title = 'Required Value'
        } 
        return response
    }
    
    amountColValidator(value, row) {
        const response = { isValid: true, notification: { type: 'success', msg: '', title: '' } }
        if (!helpers.isNumeric(value)) {
            response.isValid = false
            response.notification.type = 'error'
            // response.notification.msg = 'Value must be inserted'
            response.notification.title = 'A number is required'
        } 
        return response
    }

    addEmptyRow(){
        var fakeRow = {
            id: 'autovalue-'+new Date().getTime(),
            what: '',
            amount: null,
        }
        // insert a new row
        var result = this._table.handleAddRow(fakeRow)   // this.refs.table is a ref for BootstrapTable
        if (result){  // some error happen, ex: doesn't assign row key or row key duplicated
            console.log(result)
        }
    }

    render() {
        let dataRows = this.props.dataRows ? this.props.dataRows : []
        const options = {
            afterInsertRow: this.onAfterInsertRow.bind(this),   // A hook for after insert rows
            handleConfirmDeleteRow: this.customConfirm.bind(this),
            afterDeleteRow: this.onAfterDeleteRow.bind(this),  // A hook for after droping rows.
            insertText: this.props.insertButtonText,
            deleteText: this.props.deleteButtonText,
            defaultSortName: 'id',  // default sort column name
            defaultSortOrder: 'asc',  // default sort order
            // saveText: 'my_save',
            // closeText: 'my_close',
            // exportCSVText: 'my_export',
        }
        // If you want to enable deleteRow, you must enable row selection also.
        const selectRowProp = {
            mode: 'checkbox',
            bgColor: 'pink',
            hideSelectColumn: this.props.shouldHide,  // enable hide selection column.
            // clickToSelect: true,  // you should enable clickToSelect, otherwise, you can't select column.

        }
        const cellEditProp = {
            mode: this.props.editMode,
            blurToSave: true,
            beforeSaveCell: this.onBeforeSaveCell.bind(this), // a hook for before saving cell
            afterSaveCell: this.onAfterSaveCell.bind(this),  // a hook for after saving cell
        }
        
        return (
            <div>
                <BootstrapTable 
                    hover={this.props.showHover}
                    data={dataRows} 
                    options={options} 
                    insertRow={false} 
                    deleteRow={this.props.shouldShow} 
                    selectRow={selectRowProp}
                    cellEdit={cellEditProp}
                    ref={(c) => this._table = c}
                    //exportCSV={true}
                >
                    <TableHeaderColumn isKey dataSort autoValue={true} hidden dataField='id'>id</TableHeaderColumn>
                    <TableHeaderColumn dataField='what' width='60%' editable={{validator: this.whatColValidator}}>What</TableHeaderColumn>
                    <TableHeaderColumn dataField='amount' headerAlign='right' dataAlign='right' editable={{validator: this.amountColValidator}}>Amount</TableHeaderColumn>
                </BootstrapTable>
                {this.props.shouldShow &&
                <Button bsStyle='success' onClick={this.addEmptyRow.bind(this)}>+ Add extra row</Button>
                }
            </div>
        )
    }
}
ViabilityTable.propTypes = {
    dataRows: PropTypes.array,
    shouldShow: PropTypes.bool,
    shouldHide: PropTypes.bool,
    editMode: PropTypes.string,
    insertButtonText: PropTypes.string,
    deleteButtonText: PropTypes.string,
    onAddRow: PropTypes.func.isRequired,
    onEditRow: PropTypes.func.isRequired,
    onDeleteRow: PropTypes.func.isRequired,
    showHover: PropTypes.bool,
}

ViabilityTable.defaultProps = {
    shouldShow: true,
    shouldhide: false,
    editMode: 'click',
    insertButtonText: 'Add a row',
    deleteButtonText: 'Delete row(s)',
    showHover: true,
}
export default ViabilityTable



// WEBPACK FOOTER //
// ./src/components/ViabilityTable.js